import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import { FaWhatsapp, FaRegCopy, FaCheck } from "react-icons/fa";
import { MdShare } from "react-icons/md";

const referralLink = "https://cashkaro.com/r?r=2xxxxxxx";
const bannerImages = [
    "/assets/images/refer/banner1.png",
    "/assets/images/refer/banner2.png",
    "/assets/images/refer/banner3.png",
];
const steps = [
    { img: "/assets/images/refer/step1.png", text: "Share referral link with friends!" },
    { img: "/assets/images/refer/step2.png", text: "Let your friends shop & get Cashback!" },
    { img: "/assets/images/refer/step3.png", text: "You get 10% of your friend's Cashback" },
];

const testimonials = [
    { img: "/assets/images/refer/refer1.png", name: "Priyanka Sharma", text: "I told my friends about CashKaro, and now I've earned over ₹5000 just ..." },
    { img: "/assets/images/refer/refer2.png", name: "Ankit Ghansania", text: "I shared my referral link with my family, and they loved CashKaroNa. The..." },
    { img: "/assets/images/refer/refer3.png", name: "Viren Chaudhary", text: "I keep sharing my CashKaro referral link, and the cashback keeps comin..." },
    { img: "/assets/images/refer/refer1.png", name: "Riya Kapoor", text: "Sharing my link on WhatsApp groups got me over ₹3000 in just two months..." },
    { img: "/assets/images/refer/refer3.png", name: "Rahul Mehta", text: "My college friends started using CashKaro through my link, and now I earn..." },
];

const ReferEarn = () => {
    const navigate = useNavigate();
    const [copied, setCopied] = useState(false);
    const [email, setEmail] = useState("");
    const [bannerSlide, setBannerSlide] = useState(0);
    const [testimonialIndex, setTestimonialIndex] = useState(0);
    const cardsPerView = 3;
    const maxIndex = Math.max(testimonials.length - cardsPerView, 0);

    const handlePrevTestimonial = () => {
        setTestimonialIndex((prev) => (prev === 0 ? maxIndex : prev - 1));
    };

    const handleNextTestimonial = () => {
        setTestimonialIndex((prev) => (prev === maxIndex ? 0 : prev + 1));
    };
    useEffect(() => {
        const bannerTimer = setInterval(() => {
            setBannerSlide((prev) => (prev === bannerImages.length - 1 ? 0 : prev + 1));
        }, 4000);
        return () => clearInterval(bannerTimer);
    }, []);
    useEffect(() => {
        const timer = setInterval(() => {
            setTestimonialIndex((prev) => (prev === maxIndex ? 0 : prev + 1));
        }, 3500);
        return () => clearInterval(timer);
    }, [maxIndex]);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(referralLink);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.log("Copy failed", err);
        }
    };

    const handleInviteEmail = () => {
        if (!email) return;
        console.log("Invite sent to:", email);
        setEmail("");
    };

    const whatsappMessage = encodeURIComponent(
        "Hey! Use my CashKaroNa referral link and start earning cashback: " + referralLink
    );
    const whatsappLink = "https://wa.me/?text=" + whatsappMessage;

    return (
        <>
            <nav className="refer-breadcrumb">
                <div className="container">
                    <span onClick={() => navigate("/")}>Home</span> / <b>Refer & Earn</b>
                </div>
            </nav>

            <section className="refer-page">
                <div className="refer-grid">
                    <div className="refer-left">
                        <div className="refer-banner">
                            <img
                                src={bannerImages[bannerSlide]}
                                alt={"banner-slide-" + bannerSlide}
                                className="refer-banner-full-img"
                            />
                            <div className="refer-banner-dots">
                                {bannerImages.map((imgSrc, i) => (
                                    <span
                                        key={i}
                                        className={"dot " + (bannerSlide === i ? "active" : "")}
                                        onClick={() => setBannerSlide(i)}
                                    ></span>
                                ))}
                            </div>
                        </div>

                        <div className="refer-card">
                            <h3>How This Works?</h3>
                            <div className="refer-steps">
                                {steps.map((step, idx) => (
                                    <div className="refer-step" key={idx}>
                                        <img src={step.img} alt={"step-" + idx} />
                                        <p>{step.text}</p>
                                    </div>
                                ))}
                            </div>
                            <div className="refer-example">
                                <p>
                                    <b>For example,</b> if your friend earns ₹5000 as Cashback, you will get ₹500.
                                </p>
                                <p>This is how you enjoy a 10% bonus everytime your friend shops!</p>
                            </div>
                        </div>

                        <div className="refer-card">
                            <h3>Watch to Learn More!</h3>
                            <div className="refer-video">
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                                    title="How to refer friends and earn money"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>

                    <div className="refer-right">
                        <div className="refer-card">
                            <h4>Your Unique Referral Link</h4>
                            <div className="refer-link-box">
                                <span className="refer-link-text">{referralLink}</span>
                                <button className="copy-btn" onClick={handleCopy} type="button">
                                    {copied ? <FaCheck /> : <FaRegCopy />} {copied ? "Copied" : "Copy Link"}
                                </button>
                            </div>
                        </div>

                        <div className="refer-card">
                            <h4>Invite by Email</h4>
                            <input
                                type="email"
                                placeholder="Enter your friend's email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="refer-email-input"
                            />
                            <button className="invite-email-btn" onClick={handleInviteEmail} type="button">
                                <MdShare /> Invite via Email
                            </button>
                            <div className="refer-or">OR</div>
                            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="invite-whatsapp-btn">
                                <FaWhatsapp /> Invite via WhatsApp
                            </a>
                        </div>
                    </div>
                </div>

                <div className="refer-card refer-testimonial-fullwidth">
                    <h3>Don't Believe Us? Hear it from the Top Earners!</h3>
                    <div className="testimonial-slider-wrap">
                        <button className="slider-arrow left" onClick={handlePrevTestimonial} type="button">
                            ‹
                        </button>
                        <div className="testimonial-slider-viewport">
                            <div
                                className="testimonial-slider-track"
                                style={{
                                    transform: "translateX(-" + testimonialIndex * (100 / cardsPerView) + "%)",
                                }}
                            >
                                {testimonials.map((t, idx) => (
                                    <div className="testimonial-card" key={idx}>
                                        <img src={t.img} alt={t.name} className="testimonial-img" />
                                        <p className="testimonial-text">
                                            {t.text} <span className="see-more">See more</span>
                                        </p>
                                        <p className="testimonial-name">{t.name}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <button className="slider-arrow right" onClick={handleNextTestimonial} type="button">
                            ›
                        </button>
                    </div>
                    <div className="testimonial-dots">
                        {Array.from({ length: maxIndex + 1 }).map((_, i) => (
                            <span
                                key={i}
                                className={"t-dot " + (testimonialIndex === i ? "active" : "")}
                                onClick={() => setTestimonialIndex(i)}
                            ></span>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />

            <style jsx>{`
        * { box-sizing: border-box; }
        .refer-breadcrumb { padding: 12px 0; font-size: 0.9rem; color: #555; }
        .refer-breadcrumb span { cursor: pointer; color: var(--primary, #2f5bff); }
        .refer-page { padding: 2rem 1rem; max-width: 1200px; margin: 0 auto; width: 100%; overflow-x: hidden; }
        .refer-grid { display: grid; grid-template-columns: minmax(0, 2fr) minmax(0, 1fr); gap: 1.5rem; align-items: start; width: 100%; }
        .refer-left, .refer-right { min-width: 0; width: 100%; }
        .refer-card { background: #fff; border: 1px solid #eee; border-radius: 14px; padding: 1.6rem; margin-bottom: 1.5rem; width: 100%; min-width: 0; }
        .refer-card h3 { font-size: 1.1rem; font-weight: 700; margin-bottom: 1.2rem; }
        .refer-card h4 { font-size: 1rem; font-weight: 700; margin-bottom: 1rem; }
        .refer-testimonial-fullwidth { width: 100%; margin-top: 0.5rem; }

        .refer-banner {
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  margin-bottom: 1.5rem;
  width: 100%;
}
.refer-banner-full-img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 16px;
}
        .refer-banner-dots { position: absolute; bottom: 16px; left: 50%; transform: translateX(-50%); display: flex; gap: 6px; }
        .dot { width: 22px; height: 4px; border-radius: 2px; background: rgba(255,255,255,0.4); cursor: pointer; }
        .dot.active { background: #fff; }

        .refer-steps { display: flex; flex-direction: column; gap: 1.2rem; margin-bottom: 1.5rem; }
        .refer-step { display: flex; align-items: center; gap: 1rem; min-width: 0; }
        .refer-step img { width: 56px; height: 56px; border-radius: 50%; object-fit: cover; background: #f2f2f2; flex-shrink: 0; }
        .refer-step p { margin: 0; font-weight: 600; color: #1a2225; }

        .refer-example { background: #fff3e0; border-radius: 10px; padding: 1rem 1.2rem; }
        .refer-example p { margin: 0 0 0.4rem; font-size: 0.9rem; color: #333; }

        .refer-video { position: relative; border-radius: 14px; overflow: hidden; width: 100%; aspect-ratio: 16 / 9; }
        .refer-video iframe { position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; }

        .testimonial-slider-wrap { display: flex; align-items: center; gap: 0.8rem; width: 100%; }
        .testimonial-slider-viewport { overflow: hidden; width: 100%; }
        .testimonial-slider-track { display: flex; gap: 1.2rem; transition: transform 0.5s ease; }
        .testimonial-card { flex: 0 0 calc(33.333% - 0.8rem); border: 1px solid #eee; border-radius: 12px; padding: 1.4rem; text-align: center; box-sizing: border-box; }
        .testimonial-img { width: 64px; height: 64px; border-radius: 50%; object-fit: cover; margin-bottom: 0.8rem; }
        .testimonial-text { font-size: 0.85rem; color: #444; margin-bottom: 0.6rem; }
        .see-more { color: #2f5bff; font-weight: 600; cursor: pointer; }
        .testimonial-name { font-weight: 700; font-size: 0.9rem; color: #1a2225; }
        .slider-arrow { flex-shrink: 0; width: 36px; height: 36px; border-radius: 50%; border: 1px solid #ddd; background: #fff; font-size: 1.4rem; color: #2f5bff; cursor: pointer; display: flex; align-items: center; justify-content: center; line-height: 1; }
        .slider-arrow:hover { background: #f0f4ff; border-color: #2f5bff; }
        .testimonial-dots { display: flex; justify-content: center; gap: 6px; margin-top: 1rem; }
        .t-dot { width: 8px; height: 8px; border-radius: 50%; background: #ddd; cursor: pointer; }
        .t-dot.active { background: #2f5bff; width: 20px; border-radius: 4px; }

        .refer-link-box { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; border: 1px solid #e0e0e0; border-radius: 8px; padding: 0.6rem 0.8rem; gap: 0.5rem; width: 100%; }
        .refer-link-text { font-size: 0.8rem; color: #555; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; min-width: 0; }
        .copy-btn { display: flex; align-items: center; gap: 6px; background: none; border: none; color: #2f5bff; font-weight: 600; font-size: 0.85rem; cursor: pointer; white-space: nowrap; flex-shrink: 0; }

        .refer-email-input { width: 100%; padding: 0.7rem 0.9rem; border: 1px solid #ddd; border-radius: 8px; margin-bottom: 1rem; font-size: 0.9rem; }
        .invite-email-btn { width: 100%; background: #ff7a00; color: white; border: none; border-radius: 8px; padding: 0.8rem; font-weight: 600; display: flex; align-items: center; justify-content: center; gap: 8px; cursor: pointer; font-size: 0.9rem; white-space: nowrap; }
        .invite-email-btn:hover { background: #e56d00; }
        .refer-or { text-align: center; color: #999; font-weight: 600; margin: 1rem 0; }
        .invite-whatsapp-btn { width: 100%; background: #25d366; color: white; border: none; border-radius: 8px; padding: 0.8rem; font-weight: 600; display: flex; align-items: center; justify-content: center; gap: 8px; cursor: pointer; text-decoration: none; font-size: 0.9rem; white-space: nowrap; }
        .invite-whatsapp-btn:hover { background: #1fb956; }

        @media (max-width: 992px) { .refer-grid { grid-template-columns: 1fr; } }
        @media (max-width: 900px) { .testimonial-card { flex: 0 0 calc(50% - 0.6rem); } }
        @media (max-width: 600px) {
          .refer-banner { flex-direction: column; text-align: center; gap: 1rem; padding: 2rem 1.2rem; }
          .refer-banner-img { width: 120px; }
          .refer-page { padding: 1.2rem 0.8rem; }
          .testimonial-card { flex: 0 0 100%; }
        }
      `}</style>
        </>
    );
};

export default ReferEarn;